<template>
    <div class="quit">
        <span class="action">{{admin_name}}</span>
        <el-tooltip class="item" effect="dark" content="锁屏" placement="bottom-start">
            <span @click="lock" class="action">
                <!-- 锁屏 -->
                <i class="iconfont icon-suoping"></i>
            </span>
        </el-tooltip>
        <!-- 输入锁屏密码 -->
        <el-dialog title="设置锁屏密码" :visible.sync="box" width="30%" @open="clear" append-to-body>
            <el-form :model="form" ref="form" label-width="80px" :rule="rules">
                <el-form-item
                    label="锁屏密码"
                    prop="passwd"
                    :rules="[{ required: true, message: '锁屏密码不能为空'}]"
                >
                    <el-input v-model="form.passwd" placeholder="请输入锁屏密码"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSetLock">确 定</el-button>
            </span>
        </el-dialog>
        <el-tooltip class="item" effect="dark" content="全屏" placement="bottom-start">
            <span @click="full" class="action">
                <!-- 全屏 -->
                <i class="iconfont icon-quanping"></i>
            </span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="站内信" placement="bottom-start">
            <span class="action">
                <!-- 消息 -->
                <i class="iconfont icon-xiaoxi" style="font-size:22px"></i>
            </span>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="修改密码" placement="bottom-start">
            <span @click="editPsw" class="action">
                <!-- 修改密码 -->
                <i class="iconfont icon-xiugaimima"></i>
            </span>
        </el-tooltip>
        <!-- 修改密码 -->
        <edit-psw ref="editPsw" />
        <el-tooltip class="item" effect="dark" content="退出登录" placement="top-start">
            <span @click="loginOut" class="action">
                <!-- 退出 -->
                <i class="iconfont icon-tuichu2"></i>
            </span>
        </el-tooltip>
    </div>
</template>
<script>
import screenfull from "screenfull";
import editPsw from "../editPsw/editPsw";

export default {
    name: "quit",
    components: { editPsw },
    data() {
        return {
            isFullscreen: false,
            box: false,
            open: false,
            form: {
                passwd: ""
            },
            rules: {
                passwd: [
                    {
                        required: true,
                        message: "请输入登录账号",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: "锁屏密码长度不能小于6位数字",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed:{
         admin_name(){
            return this.$store.state.user.userInfo.admin_name
        }
    },
    methods: {
        lock() {
            this.form.passwd = "";
            this.box = true;
        },
        clear() {
            if (this.open) {
                this.$refs.form.resetFields();
            }
            this.open = true;
        },
        //全屏
        full() {
            if (!screenfull.isEnabled) {
                this.$message({
                    message: "浏览器不支持全屏",
                    type: "warning"
                });
                return false;
            }
            screenfull.toggle();
        },
        //退出登录
        loginOut() {
            this.$confirm("确定要退出当前系统吗？", "提示", {
                comfirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$store.dispatch("handleLogOut").then(res => {
                    window.location.reload();
                });
            });
        },
        // 设置锁屏
        handleSetLock() {
            this.$refs.form.validate(vailed => {
                if (vailed) {
                    this.$store
                        .dispatch("handleIsLock", this.form.passwd)
                        .then(res => {
                            window.location.reload();
                        });
                }
            });
        },
        //修改密码
        editPsw() {
            this.$refs.editPsw.show();
        }
    }
};
</script>

<style lang="less" scoped>
.quit {
    float: right;
    margin-right: 5px;
    line-height: 50px;
    span.action{
        cursor: pointer;
        font-size: 15px;
        color: #999;
        padding: 5px;
        // box-shadow: 0px 2px 2px #CCC;
        border-radius: 5px;
        i {
            color: #999999;
            font-size: 20px;
        }
    }
    span.action:hover {
        i {
            color: #2c54ce;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/acction/acction.vue